module.exports = __webpack_public_path__ + "media/images/contest_voter_campaigns/tap-icon-9a1bde365f85ee32461fc4026497fb49.png";